import React, { useState, useEffect } from "react";
import {
  Grid,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import ActionBar from "../../common/ActionBar";
import { OuterContainer } from "../../EventCreation/styles";
import { Formik } from "formik";
import styled from "styled-components";
import theme from "../../../assets/theme";
import { PrimaryCTAButton } from "../../common/Buttons";
import FormField, { ButtonContainer, FormControl } from "../FormInputs";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import EventService from "../../../services/EventService";
import { navigate } from "@reach/router";
import _ from "lodash";
import { eventSettingsValidationSchema } from "../../../helpers/validationSchema";

const EventSettings = (id) => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const [items, setItems] = useState([]);
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [clickedButton, setClickedButton] = useState("");

  const initialState = {
    primaryRtmpUrl: "",
    backupRtmpUrl: "",
    streamingKey: "",
    liveStreamPlayerUrl: "",
    highAvailabilityLink: "",
    label: "Live Stream",
  };

  const buttons = [
    {
      label: "SAVE",
      color: "default",
      primary: true,
      name: "save",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
      secondary: true,
      name: "save&next",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
      clearForm: true,
    },
  ];

  const live_page_settings_actions_two = [
    {
      name: "livePoll",
      label: "Live Poll",
      type: "switch",
    },
    {
      name: "liveTickers",
      label: "Live Tickers",
      type: "switch",
    },
    {
      name: "safeHarborMsg",
      label: "Safe Harbor Msg",
      type: "switch",
    },
  ];

  const live_page_settings_actions_three = [
    {
      name: "contentFormat",
      label: "Content Format",
      type: "radio",
      menuItems: [
        { label: "Video Only", value: "video", name: "video" },
        { label: "Audio Only", value: "audio", name: "audio" },
        {
          label: "Audio with Static Image",
          value: "audioWithStaticImage",
          name: "audioWithStaticImage",
        },
        {
          label: "Video with Slides",
          value: "videoWithSlides",
          name: "videoWithSlides",
        },
        {
          label: "Audio with Slides",
          value: "audioWithSlides",
          name: "audioWithSlides",
        },
        {
          label: "Presentation Only",
          value: "presentation",
          name: "presentation",
        },
      ],
    },
    {
      name: "uploadStaticImg",
      label: "Upload Static Image",
      type: "upload",
      accept: "image/*",
    },
  ];

  const live_page_settings_actions = [
    {
      name: "textQuestion",
      label: "Text Question",
      type: "switch",
      placeholder: "Enter text question",
    },
    {
      name: "textQuestionLabel",
      label: "Text Question Label",
      type: "text",
      placeholder: "Enter text question label",
    },
    {
      name: "videoQuestion",
      label: "Video Question",
      type: "switch",
      placeholder: "Enter video question",
    },
    {
      name: "videoQuestionLabel",
      label: "Video Question Label",
      type: "text",
      placeholder: "Enter video question label",
    },
    {
      name: "communicateTab",
      label: "Communicate Tab",
      type: "switch",
    },
    {
      name: "communicateTabLabel",
      label: "Communicate Tab Label",
      type: "text",
      placeholder: "Enter communicate tab label",
    },
    {
      name: "generalGuidelines",
      label: "General Guidelines",
      type: "switch",
    },
    {
      name: "generalGuidelinesLabel",
      label: "General Guidelines Label",
      type: "text",
      placeholder: "Enter general guideliness label",
    },
  ];

  const live_stream_platforms = [
    {
      name: "liveStream",
      label: "Live Stream",
      type: "switch",
    },
    {
      name: "youTube",
      label: "YouTube",
      type: "switch",
    },
    {
      name: "faceBook",
      label: "Facebook",
      type: "switch",
    },
    {
      name: "instagram",
      label: "Instagram",
      type: "switch",
    },
    {
      name: "linkedIn",
      label: "LinkedIn",
      type: "switch",
    },
    {
      name: "twitter",
      label: "Twitter",
      type: "switch",
    },
    {
      name: "highAvailabilityStream",
      label: "High Availability Stream",
      type: "switch",
    },
  ];

  const inputs_gallery = [
    { name: "enableGalleryView", label: "Enable Gallery View", type: "switch" },
    { name: "galleryViewUrl", label: "Gallery View URL", type: "text" },
    {
      name: "showHeader",
      label: "Show Header",
      type: "switch",
    },
    {
      name: "showFooter",
      label: "Show Footer",
      type: "switch",
    },
    {
      name: "fullName",
      label: "Full Name",
      type: "switch",
    },
    {
      name: "companyName",
      label: "Company Name",
      type: "switch",
    },
    {
      name: "emailId",
      label: "Email Id",
      type: "switch",
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      type: "switch",
    },
  ];

  const team_details = [
    {
      name: "operatorName",
      label: "Operator Name",
      type: "text",
      placeholder: "Enter operator name",
    },
    {
      name: "streamingEngineer",
      label: "Streaming Engineer",
      type: "text",
      placeholder: "Enter straming engineer",
    },
    {
      name: "onsitePerson",
      label: "Onsite Person",
      type: "text",
      placeholder: "Enter onsite person",
    },
    {
      name: "equipmentVendor",
      label: "Equipment Vendor",
      type: "text",
      placeholder: "Enter equipment vendor",
    },
    {
      name: "equipmentDetailsFile",
      label: "Equipment Details(xlsx)",
      type: "upload",
    },
    {
      name: "equipmentDetails",
      label: "Equipment Details",
      type: "textarea",
    },
  ];

  const live_stream_settings = [
    {
      name: "primaryRtmpUrl",
      label: "RTMP Primary URL",
      type: "text",
      placeholder: "Enter trmp primary url",
    },
    {
      name: "backupRtmpUrl",
      label: "RTMP Backup URL",
      type: "text",
      placeholder: "Enter rtmp backup url",
    },
    {
      name: "streamingKey",
      label: "Streaming Key",
      type: "text",
      placeholder: "Enter streaming key",
    },
    {
      name: "liveStreamPlayerUrl",
      label: "Live Stream Player URL",
      type: "text",
      placeholder: "Enter live stram player url",
    },
    {
      name: "highAvailabilityLink",
      label: "High Availability Link",
      type: "text",
      placeholder: "high availablity link",
    },
  ];

  /*

  const handleAddItem = (values, setFieldValue, name, event, label) => {
    if (event.target.checked) {
      setFieldValue(name, event.target.checked);
      const new_items = [
        ...values?.items,
        {
          primaryRtmpUrl: "",
          backupRtmpUrl: "",
          streamingKey: "",
          liveStreamPlayerUrl: "",
        },
      ];
      setFieldValue("items", new_items);
    } else {
      setFieldValue(name, event.target.checked);
      const new_items = [...values?.items].filter(
        (ci, idx) => ci.label !== label,
      );
      setFieldValue("items", new_items);
    }
  };

  */

  useEffect(() => {
    async function getEventInfo() {
      try {
        setLoader({ state: true, message: "Fetching event details..." });
        const response = await EventService.getEvent(id?.id, "livepage");
        setItems(response);
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
        window.scrollTo(0, 0);
      }
    }
    if (id?.id) {
      getEventInfo();
    } else {
      window.scrollTo(0, 0);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getEventInfo() {
    try {
      setLoader({ state: true, message: "Fetching event details..." });
      const response = await EventService.getEvent(id?.id, "livepage");
      setItems(response);
      localStorage.setItem(
        "communicate-tab",
        response?.livePageSettings?.communicateTab,
      );
    } catch (err) {
      const message = getErrorMessage(err);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description Live form submit
   */

  async function onFormSubmit(values) {
    try {
      setLoader({ state: true, message: "please wait..." });
      const payload = {
        ...values,
        liveStreamSettings: values?.items,
      };
      const response = await EventService.updateEvent(id?.id, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      if (clickedButton === "save") {
        getEventInfo();
      } else {
        localStorage.setItem(
          "communicate-tab",
          values?.livePageSettings?.communicateTab,
        );
        navigate(`/dashboard/eventmanager/theme-settings/${id?.id}`);
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  const handleAddItem = (values, setFieldValue, name, event, label) => {
    if (event.target.checked) {
      setFieldValue(name, event.target.checked);
      const new_items = [
        ...values?.items,
        {
          primaryRtmpUrl: "",
          backupRtmpUrl: "",
          streamingKey: "",
          liveStreamPlayerUrl: "",
          highAvailabilityLink: "",
          label: label,
        },
      ];
      setFieldValue("items", new_items);
    } else {
      setFieldValue(name, event.target.checked);
      const new_items = [...values?.items].filter(
        (ci, idx) => ci.label !== label,
      );
      setFieldValue("items", new_items);
    }
  };

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "event_manager":
        navigate(`/dashboard/eventmanager/form-settings/custom-filed-addition`);
        break;
      case "forms":
        id?.id
          ? navigate(
              `/dashboard/eventmanager/form-settings/custom-filed-addition/${id?.id}`,
            )
          : navigate(
              `/dashboard/eventmanager/form-settings/custom-filed-addition`,
            );
        break;
      default:
        break;
    }
  };

  /**
   * @description handle button click
   */

  const handleButtonClick = (button, resetForm, handleSubmit) => {
    if (button.clearForm) {
      resetForm();
    } else {
      setClickedButton(button.name); // Store clicked button
      handleSubmit();
    }
  };

  return (
    <OuterContainer disabled={false}>
      <ActionBar
        breadcrumbs={
          id?.id
            ? [
                "Event Manager",
                "Forms",
                "Event Settings",
                items?.eventName
                  ? `${items?.eventName} (${items?.eventDate})`
                  : "",
              ]
            : ["Event Manager", "Forms", "Event Settings"]
        }
        {...{ onBreadcrumbClick }}
      />
      <Container>
        <Formik
          initialValues={{
            livePageSettings: {
              textQuestion: items?.livePageSettings?.textQuestion || false,
              textQuestionLabel:
                items?.livePageSettings?.textQuestionLabel || "",
              videoQuestion: items?.livePageSettings?.videoQuestion || "",
              videoQuestionLabel:
                items?.livePageSettings?.videoQuestionLabel || "",
              communicateTab: items?.livePageSettings?.communicateTab || "",
              communicateTabLabel:
                items?.livePageSettings?.communicateTabLabel || "",
              generalGuidelines:
                items?.livePageSettings?.generalGuidelines || "",
              generalGuidelinesLabel:
                items?.livePageSettings?.generalGuidelinesLabel || "",
              livePoll: items?.livePageSettings?.livePoll || "",
              liveTickers: items?.livePageSettings?.liveTickers || "",
              safeHarborMsg: items?.livePageSettings?.safeHarborMsg || "",
              contentFormat: items?.livePageSettings?.contentFormat || "",
              uploadStaticImg: items?.livePageSettings?.uploadStaticImg || "",
            },
            liveStreamPlatforms: {
              liveStream: items?.liveStreamPlatforms?.liveStream || true,
              youTube: items?.liveStreamPlatforms?.youTube || "",
              faceBook: items?.liveStreamPlatforms?.faceBook || "",
              instagram: items?.liveStreamPlatforms?.instagram || "",
              linkedIn: items?.liveStreamPlatforms?.linkedIn || "",
              twitter: items?.liveStreamPlatforms?.twitter || "",
              highAvailabilityStream:
                items?.liveStreamPlatforms?.highAvailabilityStream || "",
            },
            galleryView: {
              eventTemplate: items?.eventTemplate,
              enableGalleryView: items?.galleryView?.enableGalleryView || "",
              galleryViewUrl: items?.galleryView?.galleryViewUrl || "",
              showHeader: items?.galleryView?.showHeader || false,
              showFooter: items?.galleryView?.showFooter || false,
              fullName: items?.galleryView?.fullName || "",
              companyName: items?.galleryView?.companyName || "",
              emailId: items?.galleryView?.emailId || "",
              phoneNumber: items?.galleryView?.phoneNumber || "",
              atLeastOneSelected: null,
            },
            teamDetails: {
              operatorName: items?.teamDetails?.operatorName || "",
              streamingEngineer: items?.teamDetails?.streamingEngineer || "",
              onsitePerson: items?.teamDetails?.onsitePerson || "",
              equipmentVendor: items?.teamDetails?.equipmentVendor || "",
              equipmentDetails: items?.teamDetails?.equipmentDetails || "",
              equipmentDetailsFile:
                items?.teamDetails?.equipmentDetailsFile || "",
            },
            // liveStreamSettings: {
            //   primaryRtmpUrl: items?.liveStreamSettings?.primaryRtmpUrl || "",
            //   backupRtmpUrl: items?.liveStreamSettings?.backupRtmpUrl || "",
            //   streamingKey: items?.liveStreamSettings?.streamingKey || "",
            //   liveStreamPlayerUrl:
            //     items?.liveStreamSettings?.liveStreamPlayerUrl || "",
            // },
            items: items?.liveStreamSettings?.length
              ? items?.liveStreamSettings?.map((item) => ({
                  ...item,
                  primaryRtmpUrl: item?.primaryRtmpUrl,
                  backupRtmpUrl: item?.backupRtmpUrl,
                  streamingKey: item?.streamingKey,
                  liveStreamPlayerUrl: item?.liveStreamPlayerUrl,
                  highAvailabilityLink: item?.highAvailabilityLink,
                  label: item?.label,
                }))
              : [initialState] || [initialState],
          }}
          enableReinitialize
          onSubmit={onFormSubmit}
          validationSchema={eventSettingsValidationSchema}
          validateOnBlur
          validateOnChange
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleSubmit,
            setFieldValue,
            handleChange,
            resetForm,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Event Settings</Heading>
                  <Grid container spacing={3} style={{ padding: 16 }}>
                    <Grid item xs={12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Live Page Settings</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          item
                          xs={isBigScreen ? 10 : 12}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {live_page_settings_actions.map((item, index) => (
                            <Grid
                              item
                              xs={isBigScreen ? 6 : 12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  setFieldValue,
                                  values,
                                  errors,
                                }}
                                hidden={item.hidden}
                                value={values?.livePageSettings[item.name]}
                                name={`livePageSettings.${item.name}`}
                                touched={`livePageSettings.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          item
                          xs={12}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {live_page_settings_actions_two.map((item, index) => (
                            <Grid
                              item
                              xs={isBigScreen ? 4 : 12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  setFieldValue,
                                  values,
                                  errors,
                                  touched,
                                }}
                                value={values.livePageSettings[item.name]}
                                name={`livePageSettings.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          item
                          xs={12}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {live_page_settings_actions_three.map(
                            (item, index) => (
                              <Grid
                                item
                                xs={12}
                                key={item.name}
                                style={styles.gridItem}
                              >
                                <FormField
                                  {...{
                                    item,
                                    handleChange,
                                    setFieldValue,
                                    values,
                                    errors,
                                  }}
                                  accept={item.accept}
                                  direction={"row"}
                                  error={errors?.livePageSettings?.[item.name]}
                                  helperText={
                                    errors?.livePageSettings?.[item.name]
                                  }
                                  value={values.livePageSettings[item.name]}
                                  name={`livePageSettings.${item.name}`}
                                  touched={`livePageSettings.${item.name}`}
                                />
                              </Grid>
                            ),
                          )}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={isBigScreen ? 12 : 12}>
                      <Paper
                        style={{ padding: 16, border: "1px solid #e1e3ee" }}
                      >
                        <GridLabel>Live Stream Platforms</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {live_stream_platforms.map((item, index) => (
                            <Grid
                              item
                              xs={isBigScreen ? 4 : 12}
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  setFieldValue,
                                  values,
                                  errors,
                                }}
                                handleChange={(event) =>
                                  handleAddItem(
                                    values,
                                    setFieldValue,
                                    `liveStreamPlatforms.${item.name}`,
                                    event,
                                    item.label,
                                  )
                                }
                                value={values.liveStreamPlatforms[item.name]}
                                name={`liveStreamPlatforms.${item.name}`}
                                touched={`liveStreamPlatforms.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={isBigScreen ? 12 : 12}>
                      {values?.items.map((arr, index) => (
                        <Paper
                          elevation={3}
                          style={{
                            padding: 16,
                            border: "1px solid #e1e3ee",
                            marginTop: "15px",
                            marginBottom: "15px",
                          }}
                        >
                          <GridLabel>
                            {arr.label === "Live Stream"
                              ? "Live"
                              : arr.label === "High Availability Stream"
                              ? "High Availability"
                              : arr.label}{" "}
                            Stream Settings
                          </GridLabel>
                          <Grid
                            container
                            spacing={2}
                            item
                            xs={isBigScreen ? 10 : 12}
                            style={{
                              marginTop: "16px",
                              marginLeft: isBigScreen && "10px",
                              paddingRight: isBigScreen && "15px",
                            }}
                          >
                            {live_stream_settings.map((item, idx) => (
                              <Grid
                                item
                                xs={isBigScreen ? 4 : 12}
                                key={item.name}
                                style={styles.gridItem}
                              >
                                <FormField
                                  {...{
                                    item,
                                    handleChange,
                                    setFieldValue,
                                    values,
                                    errors,
                                  }}
                                  hidden={item.hidden}
                                  value={arr[item.name]}
                                  name={`items[${index}].${item.name}`}
                                  handleChange={(event) =>
                                    setFieldValue(
                                      `items[${index}].${item.name}`,
                                      event.target.value,
                                    )
                                  }
                                  touched={`items[${index}].${item.name}`}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </Paper>
                      ))}
                    </Grid>
                    {items?.eventTemplate === "AGM" ? (
                      <Grid item xs={isBigScreen ? 12 : 12}>
                        <Paper
                          style={{
                            padding: 16,
                            border: "1px solid #e1e3ee",
                            marginTop: "16px",
                          }}
                        >
                          <GridLabel>Gallery View</GridLabel>
                          <Grid
                            container
                            spacing={2}
                            style={{
                              marginTop: "16px",
                              marginLeft: isBigScreen && "10px",
                              paddingRight: isBigScreen && "15px",
                            }}
                          >
                            {inputs_gallery.map((item, index) => (
                              <Grid
                                xs={isBigScreen ? 4 : 12}
                                item
                                key={item.name}
                                style={styles.gridItem}
                              >
                                <FormField
                                  {...{
                                    item,
                                    handleChange,
                                    setFieldValue,
                                    values,
                                    errors,
                                  }}
                                  value={values.galleryView[item.name]}
                                  name={`galleryView.${item.name}`}
                                  touched={`galleryView.${item.name}`}
                                  width={"180px"}
                                />
                              </Grid>
                            ))}
                          </Grid>
                          <div style={{ marginBottom: "20px" }}>
                            {errors?.galleryView?.atLeastOneSelected
                              ?.length && (
                              <HelperText>
                                {errors?.galleryView?.atLeastOneSelected}
                              </HelperText>
                            )}
                          </div>
                        </Paper>
                      </Grid>
                    ) : null}
                    <Grid item xs={12}>
                      <Paper
                        style={{
                          padding: 16,
                          border: "1px solid #e1e3ee",
                        }}
                      >
                        <GridLabel>Team Details</GridLabel>
                        <Grid
                          container
                          spacing={2}
                          item
                          style={{
                            marginTop: "16px",
                            marginLeft: isBigScreen && "10px",
                            paddingRight: isBigScreen && "15px",
                          }}
                        >
                          {team_details.map((item, index) => (
                            <Grid
                              xs={isBigScreen ? 4 : 12}
                              item
                              key={item.name}
                              style={styles.gridItem}
                            >
                              <FormField
                                {...{
                                  item,
                                  handleChange,
                                  setFieldValue,
                                  values,
                                  errors,
                                }}
                                value={values.teamDetails[item.name]}
                                name={`teamDetails.${item.name}`}
                                touched={`teamDetails.${item.name}`}
                              />
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <FormControl>
                      <ButtonContainer>
                        {buttons.map((button) => (
                          <PrimaryCTAButton
                            style={{ width: "auto", marginLeft: 8 }}
                            onClick={() =>
                              handleButtonClick(button, resetForm, handleSubmit)
                            }
                          >
                            {button.label}
                          </PrimaryCTAButton>
                        ))}
                      </ButtonContainer>
                    </FormControl>
                  </Grid>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "16px",
  },
  label: {
    fontWeight: "bold",
  },
};

export default EventSettings;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "15px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const HelperText = styled.div`
  position: absolute;
  font-size: 10px;
  font-family: openSans-SemiBold, sans-serif;
  color: #f44336;
`;
